import React, { useState } from 'react';
import { decodeJwt, formatJwtPayload } from '../utils/jwtUtils';
import './TokenDebugPanel.css';

export default function TokenDebugPanel({ token }) {
    const [collapsed, setCollapsed] = useState(true);
    const [showRaw, setShowRaw] = useState(false);
    const [showFull, setShowFull] = useState(false);

    if (!token) {
        return null;
    }

    const payload = decodeJwt(token);
    const fullPayload = formatJwtPayload(payload);

    return (
        <div className="token-debug-panel">
            <div className="token-debug-header">
                <h3>Token Debug Info</h3>
                <div className="token-debug-toggles">
                    <button
                        className="token-toggle-btn"
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        {collapsed ? 'Expand' : 'Collapse'}
                    </button>
                    {!collapsed && (
                        <>
                    <button
                        className="token-toggle-btn"
                        onClick={() => setShowRaw(!showRaw)}
                    >
                        {showRaw ? 'Hide' : 'Show'} Raw Token
                    </button>
                    <button
                        className="token-toggle-btn"
                        onClick={() => setShowFull(!showFull)}
                    >
                        {showFull ? 'Hide' : 'Show'} Full Claims
                    </button>
                        </>
                    )}
                </div>
            </div>

            {!collapsed && (
                <>
            {/* Raw Token */}
            {showRaw && (
                <div className="token-section">
                    <h4>Raw Token</h4>
                    <pre className="token-raw">{token}</pre>
                    <button
                        className="copy-btn"
                        onClick={() => {
                            navigator.clipboard.writeText(token);
                            alert('Token copied to clipboard');
                        }}
                    >
                        Copy Token
                    </button>
                </div>
            )}

            {/* Full Payload */}
            {showFull && (
                <div className="token-section">
                    <h4>Full Claims (Decoded)</h4>
                    <pre className="token-full">{fullPayload}</pre>
                    <button
                        className="copy-btn"
                        onClick={() => {
                            navigator.clipboard.writeText(fullPayload);
                            alert('Claims copied to clipboard');
                        }}
                    >
                        Copy Claims
                    </button>
                </div>
            )}

            {/* Validation Info */}
            {payload && (
                <div className="token-validation">
                    <h4>Token Status</h4>
                    <div className="validation-row">
                        <span>Token Type:</span>
                        <span className="validation-value">
                            JWT ({payload.typ || 'standard'})
                        </span>
                    </div>
                    <div className="validation-row">
                        <span>Expires:</span>
                        <span className={`validation-value ${payload.exp && payload.exp > Date.now() / 1000 ? 'valid' : 'expired'}`}>
                            {payload.exp ? new Date(payload.exp * 1000).toLocaleString() : 'N/A'}
                        </span>
                    </div>
                    {payload.extension_FHIRUser && (
                        <div className="validation-row success">
                            <span>FHIR User Claim</span>
                            <span className="validation-value">{payload.extension_FHIRUser}</span>
                        </div>
                    )}
                    {!payload.extension_FHIRUser && !payload.fhir_user && (
                        <div className="validation-row warning">
                            <span>No FHIR User Claim</span>
                            <span className="validation-value">extension_FHIRUser or fhir_user missing</span>
                        </div>
                    )}
                </div>
            )}
                </>
            )}
        </div>
    );
}
